class ScrollTracker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.trackEl = this.children[0];
    if (!this.trackEl) return;

    this.target = document.createElement("div");
    this.target.classList.add("scroll-tracker-target");
    this.trackEl.append(this.target);

    this.observer = new IntersectionObserver(
      (entries) => {
        this.trackEl.classList.toggle(
          "scrolled-to-end",
          entries[0].isIntersecting
        );
      },
      {
        root: this.trackEl,
        rootMargin: "1px 1px 1px 1px",
      }
    );

    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.target.remove();
    this.trackEl.classList.remove("scrolled-to-end");
  }
}

if (!customElements.get("scroll-tracker")) {
  customElements.define("scroll-tracker", ScrollTracker);
}
